module.exports = __webpack_public_path__ + "img/5.9f834b07.png";